var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoPicture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_7143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30733 2.00406C3.24905 2.01546 3.19146 2.0301 3.13483 2.04794C2.61733 2.13981 2.20108 2.51781 2.05483 3.01919C1.98326 3.26615 1.98173 3.52814 2.05039 3.77592C2.11906 4.02371 2.25523 4.24753 2.4437 4.42243L35.6004 37.5866C36.1516 38.1379 37.0366 38.1379 37.5871 37.5866C38.1376 37.0354 38.1376 36.1504 37.5871 35.5999L34.3921 32.4049C36.4595 32.1424 37.976 30.4624 37.976 28.3024V11.7203C37.976 9.3728 36.1786 7.57542 33.8304 7.57542H27.5698L26.231 4.94181C25.8159 3.97431 24.8338 3.42906 23.7283 3.42906H16.1289C15.1633 3.42906 14.2179 3.97431 13.6689 4.94181L12.3729 7.57542H9.56831L4.42932 2.43719C4.14432 2.12894 3.72808 1.97219 3.30733 2.00406ZM3.1772 8.95655C2.4872 9.64842 2.0552 10.614 2.0552 11.7203V28.3028C2.0552 30.651 3.85258 32.4487 6.19895 32.4487H26.6645L23.3398 29.1233C22.2328 29.3989 21.122 29.685 20.015 29.685C14.6301 29.685 10.3446 25.3988 10.3446 20.0115C10.3446 18.9053 10.6311 17.793 10.9063 16.6875L3.1772 8.95655ZM20.0154 10.3392C25.4019 10.3392 29.6866 14.6254 29.6866 20.0115C29.6866 22.23 28.9471 24.1688 27.7441 25.7554L25.7578 23.7686C26.4646 22.6834 26.924 21.4106 26.924 20.0111C26.924 16.1412 23.8854 13.1025 20.0154 13.1025C18.6178 13.1025 17.3439 13.5615 16.259 14.2688L14.2738 12.282C15.893 11.079 17.8888 10.3395 20.015 10.3395L20.0154 10.3392ZM13.1079 18.8892V20.0115C13.1079 23.8823 16.1465 26.9216 20.0154 26.9216C20.4279 26.9216 20.6904 26.9329 20.966 26.7911L13.1079 18.8892Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_7143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPicture);
export default __webpack_public_path__ + "static/media/no-picture.35af7f79.svg";
export { ForwardRef as ReactComponent };